import { CONSTANTS } from '@app/src/views/CipReport/filter/state/validationReportToken/constants';
import axios, { AxiosInstance } from 'axios';

export const axiosAjax = ((): AxiosInstance => axios.create({
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With':'XMLHttpRequest',
  }
}))();

axios.interceptors.response.use((response) => {
  if(response.status === 401 || response.data.code === CONSTANTS.notAuthorized) {
    localStorage.clear()
    sessionStorage.clear()
    return Promise.reject('Unauthorized');
  }
  return response
}, (error) => {
  return Promise.reject(error.message);
})

export * from 'axios';
